"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";
import { BiEnvelope, BiMap } from "react-icons/bi";
import { RxChevronRight } from "react-icons/rx";

export function Contact14() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28 bg-gray-900">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-12">
          <div>
            <div>
              <p className="mb-3 font-semibold md:mb-4 text-blue-400">Connect</p>
              <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl text-white">
                Get in Touch
              </h2>
              <p className="mb-12 md:text-md text-gray-300">We'd love to hear from you!</p>
            </div>
            
            <div className="space-y-10">
              <div>
                <div className="mb-3 md:mb-4">
                  <BiEnvelope className="size-8 text-blue-400" />
                </div>
                <h3 className="mb-2 text-md font-bold leading-[1.4] md:text-xl text-white">
                  Email
                </h3>
                <p className="mb-2 text-gray-300">Reach us anytime</p>
                <a href="mailto:info@omnigeist.com" className="text-blue-400 hover:text-blue-300">
                  info@omnigeist.com
                </a>
              </div>
              <div>
                <div className="mb-3 md:mb-4">
                  <BiMap className="size-8 text-blue-400" />
                </div>
                <h3 className="mb-2 text-md font-bold leading-[1.4] md:text-xl text-white">
                  Location
                </h3>
                <p className="mb-2 text-gray-300">Based in Miami, Florida</p>
                <p className="text-sm text-gray-400">
                  We're a virtual company serving clients worldwide
                </p>
              </div>
            </div>
          </div>

          <div className="aspect-square w-full rounded-lg overflow-hidden md:-mt-16">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d114964.38943762223!2d-80.29949920266738!3d25.782545310907384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b0a20ec8c111%3A0xff96f271ddad4f65!2sMiami%2C%20FL!5e0!3m2!1sen!2sus!4v1705687879761!5m2!1sen!2sus"
              className="size-full"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Miami, Florida location"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
